<ds-app-wrapper [menu]="menu"
  ><div class="flex-page-container">
    <router-outlet></router-outlet></div
></ds-app-wrapper>
